import {CalendarMode} from "./calendar-mode";
export class CalendarViewMode {
  name: string;
  value: CalendarMode;
  options: any;
  active: boolean = false;

  constructor(name: string, value: CalendarMode, options?: any) {
    this.name = name;
    this.value = value;
    this.options = options;
  }
}
